import { render, staticRenderFns } from "./RestoreAndDeleteProjectsDialog.vue?vue&type=template&id=c0a9f878&"
import script from "./RestoreAndDeleteProjectsDialog.vue?vue&type=script&lang=ts&"
export * from "./RestoreAndDeleteProjectsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreAndDeleteProjectsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports